<div class="help-bot-container">
  <div class="tooltip-label">Contact support</div>
  <button
    type="button"
    class="help-bot-btn"
    aria-label="Contact support"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isModalOpen"
    (click)="openHelpModal()"
  >
    <app-icon
      name="message-circle"
      class="help-bot-btn__icon"
      aria-hidden="true"
    ></app-icon>
  </button>
</div>

<div
  *ngIf="isModalOpen"
  class="help-dialog-backdrop"
  (click)="closeHelpModal()"
>
  <section
    class="help-dialog"
    appModalDialog
    (appModalDialogDismiss)="closeHelpModal()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="help-dialog-title"
    aria-describedby="help-dialog-description"
    (click)="$event.stopPropagation()"
  >
    <div class="help-dialog__header">
      <div class="help-dialog__heading">
        <span class="help-dialog__heading-icon" aria-hidden="true">
          <app-icon name="message-circle"></app-icon>
        </span>
        <div>
          <h2 id="help-dialog-title">Contact support</h2>
          <p id="help-dialog-description">
            Tell us what you need and our team will follow up by email.
          </p>
        </div>
      </div>
      <button
        type="button"
        class="help-dialog__close"
        aria-label="Close support form"
        (click)="closeHelpModal()"
      >
        <app-icon name="x" aria-hidden="true"></app-icon>
      </button>
    </div>

    <form class="help-dialog__form" (ngSubmit)="onSubmit()">
      <div
        class="form-group help-dialog__phone-group"
        [class.help-dialog__phone-group--open]="countryDropdownOpen"
      >
        <label for="support-phone">
          Phone number <span>(optional)</span>
        </label>
        <div class="cx-phone-field">
          <input
            id="support-phone"
            type="tel"
            class="form-control cx-phone-input"
            name="phoneNumber"
            [(ngModel)]="helpRequest.phoneNumber"
            placeholder="Phone number"
            maxlength="20"
            inputmode="tel"
            autocomplete="tel-national"
            [ngClass]="{ 'is-invalid': phoneError }"
          />
          <div class="cx-phone-country">
            <button
              type="button"
              class="cx-phone-country-button"
              aria-haspopup="listbox"
              [attr.aria-expanded]="countryDropdownOpen"
              [attr.aria-label]="
                'Select country code, ' +
                (selectedCountry?.callingCode || countryCode)
              "
              (click)="toggleCountryDropdown($event)"
            >
              <img
                *ngIf="selectedCountry?.flagUrl"
                [src]="selectedCountry.flagUrl"
                class="cx-phone-country-flag"
                alt=""
                aria-hidden="true"
              />
              <img
                *ngIf="!selectedCountry?.flagUrl"
                src="assets/images/flag_placeholder.png"
                class="cx-phone-country-flag"
                alt=""
                aria-hidden="true"
              />
              <span>{{ selectedCountry?.callingCode || countryCode }}</span>
              <app-icon
                name="chevron-down"
                class="cx-icon--xs"
                aria-hidden="true"
              ></app-icon>
            </button>

            <div *ngIf="countryDropdownOpen" class="cx-phone-country-menu">
              <div class="cx-phone-country-search-wrap cx-search-control">
                <app-icon
                  name="search"
                  class="cx-search-control__icon"
                  aria-hidden="true"
                ></app-icon>
                <input
                  type="search"
                  class="form-control country-search-input cx-search-control__input"
                  name="supportCountrySearch"
                  [(ngModel)]="countrySearchTerm"
                  (ngModelChange)="filterCountries()"
                  (click)="$event.stopPropagation()"
                  placeholder="Search country..."
                  autocomplete="off"
                  aria-label="Search countries"
                />
                <button
                  *ngIf="countrySearchTerm"
                  type="button"
                  class="cx-search-control__clear"
                  (click)="
                    countrySearchTerm = '';
                    filterCountries();
                    $event.stopPropagation()
                  "
                  aria-label="Clear country search"
                >
                  <app-icon name="x" aria-hidden="true"></app-icon>
                </button>
              </div>
              <div class="cx-phone-country-list" role="listbox">
                <button
                  *ngFor="let country of filteredCountries"
                  type="button"
                  class="cx-phone-country-option"
                  role="option"
                  [attr.aria-selected]="
                    selectedCountry?.countryIsoCode === country.countryIsoCode
                  "
                  (click)="selectCountry(country)"
                >
                  <img
                    [src]="country.flagUrl"
                    class="cx-phone-country-flag"
                    alt=""
                    aria-hidden="true"
                  />
                  <span class="cx-phone-country-name">{{ country.name }}</span>
                  <span class="cx-phone-country-code">
                    {{ country.callingCode }}
                  </span>
                </button>
                <p
                  *ngIf="filteredCountries.length === 0"
                  class="cx-phone-country-empty"
                >
                  No countries found.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="invalid-feedback" *ngIf="phoneError">
          Please enter a valid international phone number.
        </div>
      </div>

      <div class="form-group">
        <label for="support-issue">
          How can we help? <span class="help-dialog__required">*</span>
        </label>
        <textarea
          id="support-issue"
          class="form-control"
          name="issueDescription"
          [(ngModel)]="helpRequest.issueDescription"
          rows="5"
          placeholder="Describe the issue and include anything that will help us investigate."
          maxlength="1000"
          [ngClass]="{ 'is-invalid': issueError }"
        ></textarea>
        <div class="invalid-feedback" *ngIf="issueError">
          Please describe the issue.
        </div>
        <small>Up to 1,000 characters.</small>
      </div>

      <p class="help-dialog__account-note">
        <app-icon name="shield-check" aria-hidden="true"></app-icon>
        We’ll include your account name and email so support can follow up.
      </p>

      <p *ngIf="submitError" class="help-dialog__submit-error" role="alert">
        {{ submitError }}
      </p>

      <footer class="help-dialog__actions">
        <button
          type="button"
          class="help-dialog__cancel"
          (click)="closeHelpModal()"
        >
          Cancel
        </button>
        <button type="submit" class="help-dialog__submit">
          <app-icon name="send" aria-hidden="true"></app-icon>
          Send request
        </button>
      </footer>
    </form>
  </section>
</div>

<div
  *ngIf="isSuccessOpen"
  class="help-dialog-backdrop"
  (click)="closeSuccessModal()"
>
  <section
    class="help-dialog help-dialog--success"
    appModalDialog
    (appModalDialogDismiss)="closeSuccessModal()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="help-success-title"
    aria-describedby="help-success-description"
    (click)="$event.stopPropagation()"
  >
    <div class="help-dialog__success-icon" aria-hidden="true">
      <app-icon name="circle-check"></app-icon>
    </div>
    <h2 id="help-success-title">Request sent</h2>
    <p id="help-success-description">
      Thanks for reaching out. Our support team will contact you shortly.
    </p>
    <div class="help-dialog__actions help-dialog__actions--success">
      <button
        type="button"
        class="help-dialog__submit"
        (click)="closeSuccessModal()"
      >
        Done
      </button>
    </div>
  </section>
</div>
